import VNode from '../utils/vnode';

const boxStyles = {
  fontSize: '12px',
  color: '#fff',
  textAlign: 'center',
  margin: '0 8px',
  width: '45px',
  height: '45px',
  lineHeight: '45px',
  borderRadius: '50%',
  cursor: 'not-allowed'
}

export default new VNode({
  attrs: {
    class: 'login-footer'
  },
  styles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 0 20px 0'
  },
  children: [
    new VNode({
      content: '微信',
      styles: (() => {
        const styles = JSON.parse(JSON.stringify(boxStyles));
        styles.background = '#2d5d03';
        return styles;
      })()
    }),
    new VNode({
      content: 'QQ',
      styles: (() => {
        const styles = JSON.parse(JSON.stringify(boxStyles));
        styles.background = '#54ac5f';
        return styles;
      })(),
    }),
    new VNode({
      content: 'Github',
      styles: (() => {
        const styles = JSON.parse(JSON.stringify(boxStyles));
        styles.background = '#1f1f1f';
        return styles;
      })(),
    }),
  ]
});